import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const WidgetContext = createContext(undefined);
export function WidgetProvider({ value, children }) {
    return _jsx(WidgetContext.Provider, { value: value, children: children });
}
export function useWidgetContext() {
    const context = useContext(WidgetContext);
    if (!context) {
        throw new Error("useWidgetContext must be used within a WidgetProvider");
    }
    return context;
}
